import React from "react";
import ConfigRouter from "./ConfigRouter";
import LoadingIndicator from "./globals/Components/Loading/LoadingIndicator";
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import Releases from "./globals/Components/Releases/Releases";

class App extends React.Component {
  render() {
    return (
      <>
      <ConfigProvider locale={esES}>
      <ConfigRouter />
        <LoadingIndicator />
       
        
      </ConfigProvider>
        
      </>
    );
  }
}
export default App;